import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import i18n from 'i18next';
import { updateCarrierInformationSettings } from '../data-provider/settings/api';

export const useUpdateCarrierInformationSettings = ({ companyId }: { companyId: number }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateCarrierInformationSettings,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['claims-carrier-information-settings', companyId],
      });
      showNotification({
        type: NOTIFICATION_TYPES.SUCCESS,
        message: i18n.t('translation:claims.successfullyUpdated'),
      });
    },
    onError: (error) => {
      showNotification({
        message: error.message || i18n.t('translation:default.fields.somethingWentWrong'),
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
  });
};
